<template>
  <div class="feature-row">
    <div class="search-row">
      <div class="search-row-top">
        <el-input v-model="queryForm.keyword" class="search-input" placeholder="关键字搜索" @keyup.enter="handleFilter">
          <i slot="suffix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <div class="left-part">
        <el-select v-model="queryForm.abiBrandId" placeholder="按品牌" clearable>
          <el-option
            v-for="item in brandList"
            :label="item.abiBrandName"
            :value="item.abiBrandId"
            :key="item.abiBrandId"
          />
        </el-select>
        <!-- <el-select v-model="queryForm.categoryId" placeholder="按分类" clearable v-if="!isPrinting">
          <el-option
            v-for="item in categoryList"
            :label="item.categoryName"
            :value="item.categoryId"
            :key="item.categoryId"
          />
        </el-select> -->
        <el-select v-model="queryForm.channel" placeholder="选择渠道" clearable>
          <el-option
            v-for="item in channelList"
            :label="item.channelName"
            :value="item.channelName"
            :key="item.channelId"
          />
        </el-select>
        <el-select v-model="queryForm.produceSupplierId" placeholder="选择供应商" filterable clearable>
          <el-option
            v-for="item in supplierList"
            :label="item.supplierName"
            :value="item.supplierId"
            :key="item.supplierId"
          />
        </el-select>
        <span class="search-text">价格区间</span>
        <el-input v-model="queryForm.minPrice" class="price-input" @keyup.native="minNumber"></el-input>
        <span class="search-text">至</span>
        <el-input v-model="queryForm.maxPrice" class="price-input" @keyup.native="maxNumber"></el-input>
        <el-button type="danger" class="btn-red" @click="handleFilter">搜索</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import baseApi from '@/api/base'
export default {
  name: 'SearchRow',
  data () {
    return {
      brandList: [],
      categoryList: [],
      channelList: [],
      supplierList: [],
      queryForm: {
        abiBrandId: '',
        channel: '',
        categoryId: '',
        keyword: '',
        minPrice: '',
        maxPrice: '',
        produceSupplierId: ''
      }
    }
  },
  computed: {
    isPrinting () {
      return (
        this.$route.name === 'printing-favourite' ||
        this.$route.name === 'printing-list'
      )
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.getBrand()
      this.getCategory()
      this.getChannel()
      this.getSupplier()
    },
    // 品牌
    getBrand () {
      baseApi.getBrand().then(res => {
        if (res.data.resultCode === '0') {
          this.brandList = res.data.resultData.brandList
        }
      })
    },
    // 分类
    getCategory () {
      baseApi.getCategory().then(res => {
        if (res.data.resultCode === '0') {
          this.categoryList = res.data.resultData.categoryList
        }
      })
    },
    // 渠道
    getChannel () {
      baseApi.getChannel().then(res => {
        if (res.data.resultCode === '0') {
          this.channelList = res.data.resultData.baseChannelList
        }
      })
    },
    // 供应商
    getSupplier () {
      baseApi.getProduceSupplier().then(res => {
        if (res.data.resultCode === '0') {
          this.supplierList = res.data.resultData.baseLogisticsSupplierList
        }
      })
    },
    // 搜索
    handleFilter () {
      this.$emit('handleFilter', this.queryForm)
    },

    minNumber () {
      // eslint-disable-next-line no-useless-escape
      this.queryForm.minPrice = this.queryForm.minPrice.replace(/[^\.\d]/g, '').replace('.', '')
    },
    maxNumber () {
      // eslint-disable-next-line no-useless-escape
      this.queryForm.maxPrice = this.queryForm.maxPrice.replace(/[^\.\d]/g, '').replace('.', '')
    }
  }
}
</script>

<style lang="scss" scoped>
.search-row {
  margin-bottom: 15px;
  line-height: 36px;
  .search-row-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: -15px;
    .entity-name {
      font-weight: bold;
    }
    margin-bottom: 10px;
  }
  .search-input.el-input {
    width: 300px;
    height: 36px;
    margin-right: $content-middle;
    input::-webkit-input-placeholder {
      color: #000;
    }
  }
  .price-input {
    width: 65px;

    ::v-deep .el-input__inner {
      padding: 0 5px;
    }
  }
  .search-text {
    font-size: $font-12;
    display: inline-block;
    height: 34px;
    padding: 0 5px;
    background-color: #d8d8d8;
  }
}
.el-select {
  width: 125px;
  height: 36px;
}
.el-button {
  height: 36px;
  margin-left: 10px;
}
.feature-row {
  margin-bottom: $content-middle;
}
</style>
